import React from 'react';
import FerrisIcon from '../Assets/Images/ferris.webp'

function NotFound() {
    return (
        <div className='d-flex align-items-center justify-content-center w-100' style={{height:'100vh'}}>
            <div className='text-center p-3'>
                <img src={FerrisIcon} style={{maxWidth:150}} alt='Icon'/>
                <h1 className='fw-bold'>Invalid Page</h1>
                <p>The page your are looking for does not exist.</p>
            </div>
        </div>
    );
}

export default NotFound;